export const PAYMENT_TABS = {
  CARD: "card",
  LINK: "link",
  CASH: "cash",
  OTHERS: "others"
}

export const LINK_PROVIDERS = {
  STRIPE: "stripe",
  PAYPAL: "paypal"
}

export const OTHERS_TYPES = [
  { value: "check", label: "Check" },
  { value: "e_transfer", label: "E-Transfer" },
  { value: "pay_pal", label: "Paypal" },
  { value: "zelle", label: "Zelle" },
  { value: "venmo", label: "Venmo" },
  { value: "other", label: "Other" }
]

export const paymentProvider = {
  card: "stripe",
  link: "stripe",
  paypalLink: "paypal"
}

// The tip's own outcome on a card payment (payments/record response `tip.status`). The tip is a
// separate charge from the booking payment, so the booking's `succeeded` says nothing about it.
export const TIP_STATUS = {
  COMPLETED: "completed",
  // Not charged yet: confirm with tip.client_secret, then capture it.
  PENDING: "pending",
  FAILED: "failed"
}

// What Collect Payment does with a tip after the booking charge — see getTipAction.
export const TIP_ACTION = {
  NONE: "none",
  CONFIRM: "confirm",
  WARN: "warn"
}
